import React from 'react';
import { Link } from 'react-router-dom';
import { Col, Row } from 'reactstrap';

/**
 * Hotfix 10 — Made the breadcrumb segments actually navigable.
 *
 * Pre-hotfix: pageTitle rendered as <Link to="#"> (dead anchor),
 * title rendered as plain "active" text. So clicking either did
 * nothing — users couldn't navigate back via the breadcrumb.
 *
 * Now:
 *   • `pageTitleTo` — optional href for the first segment. If
 *     provided, renders as a real <Link>; otherwise renders as a
 *     dead anchor for visual back-compat.
 *   • `titleTo`     — optional href for the second segment. If
 *     provided, renders as a <Link> (not active); otherwise renders
 *     as plain active text (existing behavior preserved).
 *
 * Existing call sites without the new props keep working unchanged.
 */
const BreadCrumb = ({ title, pageTitle, pageTitleTo, titleTo }) => {
    return (
        <React.Fragment>
            <Row>
                <Col xs={12}>
                    <div className="page-title-box d-sm-flex align-items-center justify-content-between">


                        <div className="page-title-left">
                            <ol className="breadcrumb m-0">
                                <li className="breadcrumb-item">
                                    {pageTitleTo
                                        ? <Link to={pageTitleTo}>{pageTitle}</Link>
                                        : <Link to="#">{pageTitle}</Link>}
                                </li>
                                <li className={`breadcrumb-item ${titleTo ? "" : "active"}`}>
                                    {titleTo
                                        ? <Link to={titleTo}>{title}</Link>
                                        : title}
                                </li>
                            </ol>
                        </div>

                    </div>
                </Col>
            </Row>
        </React.Fragment>
    );
};

export default BreadCrumb;
